import React, { PropsWithChildren } from 'react';
import { Spinner } from 'react-bootstrap';

import './index.scss';

export type SheetActionButtonVariant = 'confirm' | 'secondary' | 'clear';

export default function SheetActionButton({
  variant,
  onClick,
  disabled,
  loading,
  className,
  children,
}: PropsWithChildren<{
  variant: SheetActionButtonVariant;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
}>) {
  return (
    <button
      type="button"
      className={`mobile-sheet-action mobile-sheet-action-${variant}${className ? ` ${className}` : ''}`}
      disabled={disabled}
      onClick={onClick}
    >
      {loading && <Spinner animation="border" size="sm" className="me-2" />}
      {children}
    </button>
  );
}
